import { render } from "./multi-baccarat-bet-view.vue?vue&type=template&id=8fa2b478&scoped=true"
import script from "./multi-baccarat-bet-view.vue?vue&type=script&lang=js"
export * from "./multi-baccarat-bet-view.vue?vue&type=script&lang=js"

import "./multi-baccarat-bet-view.vue?vue&type=style&index=0&id=8fa2b478&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa2b478"]])

export default __exports__